import { Box, Typography } from "@mui/material";
import { useScrapEyeMetadata } from "src/contexts/scrapEyeMetadata";
import { pickAreaColorFromIndex } from "src/utils/areaColor";

export const AreaLabel = ({
  area,
  label,
}: {
  area: string | null;
  label: string;
}) => {
  const { available_areas: availableAreas } = useScrapEyeMetadata();
  if (!area) return null;
  const color = pickAreaColorFromIndex(availableAreas.indexOf(area));
  return (
    <Box
      data-testid="area-label"
      sx={{
        px: 1,
        py: 0.25,
        borderRadius: 1,
        backgroundColor: color,
      }}
    >
      <Typography
        variant="caption"
        sx={{
          fontWeight: "bold",
          color: "text.primary",
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};
